// ArticleImage.jsx
import React from "react";

function ArticleImage({
  src,
  alt,
  className = "",
  focusX = 50,
  focusY = 50,
  loading = "lazy",
  decoding = "async",
  ...rest
}) {
  return (
    <img
      src={src}
      alt={alt}
      loading={loading}
      decoding={decoding}
      className={`w-full h-full object-cover rounded ${className}`}
      style={{
        objectPosition: `${focusX}% ${focusY}%`,
      }}
      {...rest}
    />
  );
}

export default ArticleImage;
